import {
  Heading,
  Highlight,
  Box,
  Text,
  type BoxProps,
  type HeadingProps,
  type SystemStyleObject,
  type TextProps,
} from "@chakra-ui/react";
import React from "react";

interface WithHeading3Props {
  children: React.ReactNode;
  query?: string[];
  styles?: SystemStyleObject;
  size?: HeadingProps["size"];
  pt?: BoxProps["pt"];
  textAlign?: BoxProps["textAlign"];
  color?: TextProps["color"];
  fontWeight?: HeadingProps["fontWeight"];
}

export default function WithHeading3({
  children,
  query = [],
  styles = { px: "0.5" },
  size = { base: "md", md: "lg" },
  pt = { base: 2, md: 3 },
  textAlign = { base: "center", md: "left" },
  color = "moveon.publicFont",
  fontWeight = "semibold",
}: WithHeading3Props) {
  const highlightStyles: SystemStyleObject = { ...styles, color };

  return (
    <Box pt={pt} textAlign={textAlign}>
      <Heading as="h3" size={size} fontWeight={fontWeight} mb="2">
        {query.length > 0 ? (
          <Text as="span" color={color}>
            <Highlight query={query} styles={highlightStyles}>
              {String(children)}
            </Highlight>
          </Text>
        ) : (
          <Text as="span" color={color}>
            {children}
          </Text>
        )}
      </Heading>
    </Box>
  );
}
